module.exports = __webpack_public_path__ + "static/media/faq1.1f59ac91.webp";